import {z} from "zod/v4-mini"
import type {GraphNodeDefinition} from "#graph/nodes/graph/types"

export const dynamicParameterDefinition = <ValueType>(nodeClass: string, valueSchema: z.ZodMiniType<ValueType, ValueType>) =>
    ({
        nodeClass,
        validation: {
            parameters: z.strictObject({value: valueSchema}),
            returns: z.any(),
        },
    }) satisfies GraphNodeDefinition<unknown, {value: ValueType}>
